import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';

@Component({
  selector: 'user-devices',
  templateUrl: './user-devices.template.html',
  styleUrls: ['./user-devices.style.scss']
})
export class UserDevices implements OnInit {

  @Input() devices: any;
  @Input() promptItem: string;
  constructor(
    private cd: ChangeDetectorRef,
    private coreEffects: CoreEffects
  ) { 
    
  }

  ngOnInit() {
  }

  removeDevice(deviceId){
    this.coreEffects.removeRegisteredDevice(deviceId);
    this.devices = this.devices.filter(item => item.uuid !== deviceId);
    this.cd.detectChanges();
    //console.log('removed');
  }

  public getImage( deviceType : string ){
    if( deviceType.indexOf("Apple TV") != -1){
      return '/images/device_apple_tv.png';
    }else if( deviceType.indexOf("Roku") != -1){
      return '/images/device_roku.png';
    }else if( deviceType.indexOf("Fire TV") != -1){
      return '/images/device_firetv.png';
    }
  }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/user-devices/user-devices.component.ts